export const UNIQUE_MESSAGE_BODY_ID = 'UniqueMessageBody';
export const UNIQUE_MESSAGE_BODY_SELECTOR: '[id^=UniqueMessageBody]' = `[id^=${UNIQUE_MESSAGE_BODY_ID}]`;
